import { render, staticRenderFns } from "./PassportTable.vue?vue&type=template&id=9c57f808&scoped=true"
import script from "./PassportTable.vue?vue&type=script&lang=js"
export * from "./PassportTable.vue?vue&type=script&lang=js"
import style0 from "./PassportTable.vue?vue&type=style&index=0&id=9c57f808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c57f808",
  null
  
)

export default component.exports